export const HYDRA_TEST_VARIABLE = 'htv'; // currently not a real test; used for documentation and unit testing
export const HYDRA_PUSH_NOTIFICATIONS = 'mpn';
export const HYDRA_BRAND_NAME_SEARCH = 'bnsr'; // [B]rand [N]ame [S]ea[R]ch
export const HYDRA_6PM_MARTY_RETURNS = '6mrt'; // [6]pm [M]arty [R]e[t]urns
export const HYDRA_STREAM_RESPONSE = 'strm'; // Response [Str]ea[m]ing
export const HYDRA_CHECKOUT_SHIPPING_DOWNGRADE = 'csd'; // [C]heckout [S]hipping [D]owngrade
export const HYDRA_FONT_PRELOAD = 'fp'; // [F]ont [P]reload
export const HYDRA_CHECKOUT_STICKY_PLACE_ORDER = 'cspo'; // Sticky Place Order
export const HYDRA_DOUBLE_PRODUCT_REMOVE = 'dz0s'; // [D]ouble [Z]appos [0S]
export const HYDRA_SEARCH_SPELLCHECK = 'seas'; // [SEA]rch [S]pellcheck
export const HYDRA_IMAGES_BY_ZYCADA = 'izy'; // [I]mages By [Zy]cada
export const HYDRA_STICKY_ADD_TO_CART = 'stack'; // [ST]icky [A]dd to [C]art with an extra [K]
export const HYDRA_REVIEW_INCENTIVE = 'rice'; // [R]eview [I]n[CE]ntive
export const HYDRA_CHECKOUT_NO_PAYMENT_MSG = 'cnpm'; // [C]heckout No Payment Message
export const HYDRA_PRIME_TWO_DAY_SHIPPING = 'ptds'; // [P]rime [T]wo [D]ay [S]hipping
export const HYDRA_REMOVE_REFERRER_RECOS = 'brrr'; // [B]yeeeee [R]emove [R]eferrer [R]ecos
export const HYDRA_CHECKOUT_VIP_ONE_DAY_SHIPPING = 'cvod'; // [C]heckout [V]IP [O]ne [D]ay Shipping
export const HYDRA_CHECKOUT_PRIME_PERK = 'cpp'; // [C]heckout [P]rime [P]erk
export const HYDRA_HOW_IT_WAS_WORN = 'hiww'; // [H]ow [I]t [W]as [W]orn
export const HYDRA_CHECKOUT_RIGHT_COL_REWARDS = 'crcr'; // [C]heckout [R]ight [C]olumn [R]ewards
export const HYDRA_CHECKOUT_PRIVATE_LABEL_CREDIT_CARD = 'cplc'; // [C]heckout [P]rivate [L]abel Credit [C]ard
export const HYDRA_SHIPPING_DATES = 'sd'; // [S]hipping [D]ates
export const HYDRA_PRICE_RANGE_SLIDER = 'prsd'; // [P]rice [R]ange [S]li[d]er
export const HYDRA_MICROSOFT_SPONSORED_PRODUCTS = 'msft'; // [M]icro[S]o[F][T]
export const HYDRA_ORDER_CONFIRMATION_ROKT_ADS = 'ocra'; // [O]rder [C]onfirmation [R]okt [A]ds
export const HYDRA_NEW_SEARCH_NAV = 'nsn'; // [N]ew [S]earch [N]av
export const HYDRA_HEARTS_STARS = 'hast'; // [H]earts [A]nd [ST]ars
export const HYDRA_PRODUCT_DESC_SEARCH_INDEX = 'pdsi'; // [P]roduct [D]escription in [S]earch [I]ndex
export const HYDRA_ZFC_DIAMOND = 'zfcd'; // [ZFC] [D]iamond
export const HYDRA_SEARCH_AUTOCORRECT = 'auto'; // Search [AUTO]correct
export const HYDRA_CUST_ALSO_BOUGHT_THESE = 'cabt'; // [C]ustomers [A]lso [B]ought [T]hese
export const HYDRA_CHECKOUT_DYNAMIC_SHIP_LABELS = 'cdsl'; // [C]heckout [D]ynamic [S]hip [L]abels
export const HYDRA_ADDRESS_AUTO_COMPLETE = 'aac'; // [A]ddress [A]uto [C]omplete
export const HYDRA_SOLR_MINIMUM_MATCH_TERM = 'smmt'; // [S]olr [M]inimum [M]atch [T]erm
export const HYDRA_CHECKOUT_SHIPPING_DATES = 'csda'; // [C]heckout [S]hipping [Da]tes
export const HYDRA_COLLECTION_CAROUSEL = 'cca'; // [C]ollection [CA]rousel
export const HYDRA_CHECKOUT_GIFT_OPTIONS = 'cgo'; // [C]heckout [G]ift [O]ptions
export const HYDRA_CHECKOUT_NEXT_DAY_SHIPPING = 'cnds'; // [C]heckout [N]ext [D]ay [S]hipping
export const HYDRA_SIZE_BIAS_KIDS = 'sbks'; // [S]ize [B]ias [K]id[S]
export const HYDRA_REMOVE_FACET_COUNT = 'hrfc'; // [H]ydra [R]emove [F]acet [C]ount
export const HYDRA_FILTER_KEYWORD = 'fkw2'; // [F]ilter [K]ey[W]ord
export const HYDRA_BLUE_SKY_PDP = 'oidia'; // [O]ops [I] [D]id [I]t [A]again.... #FreeBritney
